import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import tasksIcon from "../../../../assets/images/svg/tasks.svg";
import allReadyForRepair from "../../../../assets/images/svg/spareParts.svg";
import depotIcon from "../../../../assets/images/svg/depot.svg";
import BackButtonLink from "components/Common/buttons/BackButtonLink";
import { boolFormatter } from "components/Common/formatter";
import classnames from "classnames";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 15,

    "@media (max-width: 576px)": {
      justifyContent: "space-between",
      width: "100%",
    },
  },
  mainInfo: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 8px 16px 0 #00000014",
    borderRadius: 100,
    height: 60,

    "@media (max-width: 576px)": {
      flexDirection: "column",
      height: "auto",
      borderRadius: 12,
      width: "100%",
      alignItems: "flex-start",
      padding: 10,
      gap: 10,
    },
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(180deg, #00C2FF 0%, #0085FF 100%)",
    boxShadow: "0 8px 16px 0 #00000014",
    borderRadius: 100,
    height: 60,
    marginLeft: 20,
  },
  iconButton: {
    display: "flex",
    alignItems: "center",
    padding: "0 20px",

    "& img": {
      width: 20,
    },

    "& :hover": {
      cursor: "pointer",
      opacity: 0.7,
    },
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: 23,

    "& span": {
      fontSize: 16,
      fontWeight: 600,
      marginBottom: 4,
    },
  },
  status: {
    color: "#FFFFFF",
    fontSize: 9,
    fontWeight: 300,
    backgroundColor: "#17C347",
    textTransform: "uppercase",
    padding: "3px 8px",
    borderRadius: 6,
    letterSpacing: "0.05em",

    "@media (max-width: 576px)": {
      width: "100%",
      textAlign: "center",
    },
  },
  section: {
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    width: 180,

    "& img": {
      width: 30,
      marginRight: 10,
    },

    "@media (max-width: 576px)": {
      width: "100%",
      padding: 0,

      "&>div": {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      },
    },
  },
  title: {
    color: "#666666",
    fontSize: 9,
    fontWeight: 300,
  },
  data: {
    fontSize: 11,
    fontWeight: 600,

    "@media (max-width: 576px)": {
      textAlign: "end",
    },
  },
  overflowText: {
    overflow: "hidden",
    width: 100,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",

    "@media (max-width: 576px)": {
      width: "100%",
    },
  },
  divider: {
    height: "100%",
    width: 2,
    backgroundColor: "#0000000F",
  },
  rightContainer: {
    display: "flex",
    marginTop: 10,

    "@media (max-width: 576px)": {
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center",
      marginBottom: 10,
    },
  },
});

const Header = ({ id, initialValues = {} }) => {
  // const { state } = initialValues;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <BackButtonLink to={"/warehouse/assets"}>Back</BackButtonLink>

        <div className={classes.nameContainer}>
          <span>{id}</span>
          <div className={classes.status}>{initialValues?.state}</div>
        </div>
      </div>
      <div className={classes.rightContainer}>
        <div className={classes.mainInfo}>
          <div className={classes.section}>
            <div>
              <div className={classes.title}>IS VALIDATED</div>
              <div className={classes.data}>{boolFormatter(initialValues?.isValidated)}</div>
            </div>
          </div>
          <div className={classes.section}>
            <img src={tasksIcon} alt="task count" />
            <div>
              <div className={classes.title}>ASSET TYPE GROUP</div>
              <div className={classnames(classes.data, classes.overflowText)}>{initialValues?.typeGroup}</div>
            </div>
          </div>
          <div className={classes.section}>
            <img src={allReadyForRepair} alt="task count" />
            <div>
              <div className={classes.title}>CONDITION</div>
              <div className={classnames(classes.data, classes.overflowText)}>{initialValues?.condition}</div>
            </div>
          </div>
          <div className={classes.section}>
            <img src={depotIcon} alt="task count" />
            <div>
              <div className={classes.title}>DEPOT</div>
              <div title={initialValues?.depot} className={classnames(classes.data, classes.overflowText)}>
                {initialValues?.depot}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
